import React from "react";
import { connect } from "react-redux";
import { compose, withHandlers } from "recompose";
import { reduxForm } from "redux-form";

import Dialog from "./DialogWrap";

import {
  deleteResource,
  getResourcesForAdmin
} from "../../actions/resourceActions";

const AdminResourcesRemoveResource = ({ handleSubmit, data }) => (
  <Dialog
    title="Odstranit zdroj"
    name="AdminResourcesRemoveResource"
    handleSubmit={handleSubmit}
    submitLabel="Odstranit"
  >
    <p>Odstranit zdroj?</p>
  </Dialog>
);

export default compose(
  connect(
    ({ dialog: { data } }) => ({
      data
    }),
    { deleteResource, getResourcesForAdmin }
  ),
  withHandlers({
    onSubmit: dialog => async (formData, dispatch, props) => {
      const { deleteResource, getResourcesForAdmin, data, history } = props;

      if (await deleteResource(data.id)) {
        getResourcesForAdmin();
        dialog.closeDialog();
        history.push("/resources");
      }
    }
  }),
  reduxForm({
    form: "adminResourcesRemoveResourceForm"
  })
)(AdminResourcesRemoveResource);



// WEBPACK FOOTER //
// ./src/components/dialogs/AdminResourcesRemoveResource.js